import { render, staticRenderFns } from "./Sharepoint.vue?vue&type=template&id=43c07281&"
import script from "./Sharepoint.vue?vue&type=script&lang=js&"
export * from "./Sharepoint.vue?vue&type=script&lang=js&"
import style0 from "./Sharepoint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports